import React from "react";
import DatePicker from "./DatePicker";
import { selectFocussedEvent } from "../redux/selectors";
import { connect } from "react-redux";
import EmployeesDetail from "./EmployeesDetail";
import MachinesDetail from "./MachinesDetail";
import EquipmentDetail from "./EquipmentDetail";
import JobpacksDetail from "./JobpacksDetail";
class DetailView extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="CalendarView">
                    <div className="CalendarView-Calendar" style={{ fontSize: "12px" }}>
                        <DatePicker />
                    </div>
                    <div className="CalendarView-Event" style={{ fontSize: "12px" }}>
                        {this.props.focussedEvent.type === "employees" && <EmployeesDetail />}
                        {this.props.focussedEvent.type === "equipment" && <EquipmentDetail />}
                        {this.props.focussedEvent.type === "machines" && <MachinesDetail />}
                        {this.props.focussedEvent.type === "jobpack" && <JobpacksDetail />}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default connect(
    store => {
        return {
            focussedEvent: selectFocussedEvent(store)
        };
    },
    {}
)(DetailView);
